import type {
  NewApiErrorResponse,
  UseAppMutationOptions
} from '@libs/data-access/queries'
import { useMutation } from '@tanstack/react-query'

import type { PutLineManagerOptions } from '../lineManagers.api'
import { putLineManager } from '../lineManagers.api'
import { lineManagerQueryKeys } from '../lineManagers.cacheKeys'

export const usePutLineManager = (
  mutationOpts?: UseAppMutationOptions<
    {},
    NewApiErrorResponse,
    PutLineManagerOptions
  >
) => {
  return useMutation<{}, NewApiErrorResponse, PutLineManagerOptions>({
    ...mutationOpts,
    mutationKey: lineManagerQueryKeys.put_line_manager(),
    mutationFn: opts => putLineManager(opts),
    onSuccess: (...args) => {
      mutationOpts?.onSuccess?.(...args)
    }
  })
}
